import { serverAxios } from '@/shared/api';

export const cancelWithdrawalApi = async () => {
  return await serverAxios.patch(
    `${process.env.NEXT_PUBLIC_APP_BASE_API_URL}/member/withdrawal/cancel/`
  );
};
